import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import { MDBDataTableV5 } from 'mdbreact';
import { numberFormat } from '../../../config/numberFormat';
import SaleTotalsCards from './SaleTotalsCards';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Link } from 'react-router-dom';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Loader } from '@progress/kendo-react-indicators';
import DownloadBtnSaleInvoicePdf from '../Invoices/Sale/DownloadBtnSaleInvoicePdf';
import PrintBtnSaleInvoicePdf from '../Invoices/Sale/PrintBtnSaleInvoicePdf';
import DownloadBtnSaleReturnInvoicePdf from '../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf';
import PrintBtnSaleReturnInvoicePdf from '../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf';


let _UserSession = localStorage.getItem('vs_UserSession');
let _signingId = '0';
let _businessId = '0';
let _companyId = '0';
let _businessSetting = {};

if(_UserSession!=undefined || _UserSession!=null)
{
    _UserSession = JSON.parse(_UserSession);
    _signingId = _UserSession.loginId;
    _businessId = _UserSession.tokenKey;
    _businessSetting = _UserSession.businessSetting;
}

let _companySession = localStorage.getItem('vs_UserCompanySession');
if(_companySession!=undefined || _companySession!=null)
{
    _companySession = JSON.parse(_companySession);
    _businessId = _companySession.business_id;
    _companyId = _companySession.company_id;
}

let columns = [
    {
        label: '#',
        field: 'srNo',
        width: 20,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': '#',
        },
    },
    {
        label: 'Date',
        field: 'invoice_date',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Date',
        },
    },
    {
        label: 'Ref No.',
        field: 'invoice_no',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Ref No.',
        },
    },
    {
        label: 'Party Name',
        field: 'party_name',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Party Name',
        },
    },
    {
        label: 'Type',
        field: 'payment_type',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Type',
        },
    },
    {
        label: 'Amount',
        field: 'total_amount',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Amount',
        },
    },
    {
        label: 'Paid Amount',
        field: 'received_amount',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Received Amount',
        },
    },
    {
        label: 'Balance Amount',
        field: 'balance_amount',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Balance Amount',
        },
    },
    {
        label: 'Status',
        field: 'pay_status',
        width: 150
    },
    {
        label: 'Action',
        field: 'action',
        width: 100,
    }
];

let _loader = 'glb-ldr-prt active';

export default class userSaleListPanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            buttonTitle:'Add Sale',
            isLoaded : true,
            transactionArray :[],
            transactionArrayFilter:[],
            businessId:_businessId,
            company_id:_companyId,
            userId : _signingId,
            name :  null,
            isLoading: false,
            isPdfLoading: false,
            paidAmount:0,
            unpaidAmount:0,
            total:0,
            startDate : moment().startOf('month').format('YYYY-MM-DD'),
            endDate : moment().endOf('month').format('YYYY-MM-DD'),
            typeFilter : 'Both',
            paymentStatusFilter : 'ALL',
            dateLabel : '',

            pageCount : 10,
            page : 1,
            totalCount  : 0,
            pageShow  : 0,
            setPage : 1,
            searchInvNo : '',
            
            errors: {
                name : '',
            }
        }
    }

    async componentDidMount ()
    {
        this.getSaleListData(this.state.page,this.state.searchInvNo,this.state.pageCount);
    }

    exportToExcel = () => {
        this.setState({ isExporting: true });
        const requestData = JSON.stringify({
            business_id: this.state.businessId,
            company_id: this.state.company_id,
            type: this.state.typeFilter,
            payment_status: this.state.paymentStatusFilter,
            isDateFilter: true,
            start_date: this.state.startDate,
            end_date: this.state.endDate,
            pageCount: 100000,
            search_inv_no: this.state.searchInvNo,
            page: 1,
        });

        PostData(global.userSaleTransactionList, requestData, 'POST')
            .then((result) => {
                let rows = [];
                if (result && result.success && Array.isArray(result.response)) {
                    rows = result.response;
                } else if (Array.isArray(this.state.itemArray)) {
                    rows = this.state.itemArray;
                }
                this.downloadExcelRows(rows);
            })
            .catch(() => {
                this.downloadExcelRows(this.state.itemArray || []);
            })
            .finally(() => this.setState({ isExporting: false }));
    }

    downloadExcelRows = (rows) => {
        try {
            if (!rows || rows.length === 0) {
                sendNotification("Warning Message 😓", "No records available to export.", "warning");
                return;
            }

            let totalAmount = 0;
            let receivedAmount = 0;
            let balanceAmount = 0;

            const sheetRows = rows.map((data, idx) => {
                const amt = parseFloat(data.total_amount) || 0;
                const recv = parseFloat(data.received_amount || data.paid_amount) || 0;
                const bal = parseFloat(data.balance) || 0;
                totalAmount += amt;
                receivedAmount += recv;
                balanceAmount += bal;
                return {
                    '#': idx + 1,
                    'Date': data.invoice_date || '',
                    'Invoice No': data.invoice_no || '',
                    'Party Name': data.party_name || '',
                    'Party Phone': data.party_phone || '',
                    'Type': data.type || data.sale_type || '',
                    'Total Amount': amt,
                    'Received Amount': recv,
                    'Balance Due': bal,
                    'Payment Status': data.payment_paid || '',
                    'Payment Type': data.payment_type || '',
                    'Description': data.description || '',
                };
            });

            sheetRows.push({});
            sheetRows.push({
                '#': '',
                'Date': '',
                'Invoice No': '',
                'Party Name': '',
                'Party Phone': '',
                'Type': 'Total',
                'Total Amount': totalAmount,
                'Received Amount': receivedAmount,
                'Balance Due': balanceAmount,
                'Payment Status': '',
                'Payment Type': '',
                'Description': '',
            });

            const ws = XLSX.utils.json_to_sheet(sheetRows);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sale Return List');

            const wbout = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
            const fileName = 'sale_return_list_' + moment().format('YYYY-MM-DD_HH-mm') + '.xlsx';
            const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, fileName);

            sendNotification("Success Message 👍", "Sale return list exported successfully.", "success");
        } catch (err) {
            sendNotification("Error Message 😓", "Failed to export sale return list.", "danger");
        }
    }

    getInvoiceSearch = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let _valueSend = value;
        this.setState({searchInvNo:_valueSend})
        if(_valueSend.length >= 3 || _valueSend == ''){
            this.getSaleListData(this.state.page,_valueSend,this.state.pageCount);
        }
    }
    getTransactionAmountCalculate(_page,searchInvSend,pageCount, typeFilter, paymentStatusFilter){
        const requestData = JSON.stringify({
            business_id: this.state.businessId,
            company_id: this.state.company_id,
            type: typeFilter,
            payment_status: paymentStatusFilter ? paymentStatusFilter : this.state.paymentStatusFilter,
            isDateFilter: true,
            start_date: this.state.startDate,
            end_date: this.state.endDate,
            pageCount: pageCount,
            page: _page,
            search_inv_no:searchInvSend,
        });

        PostData(global.userSaleTransactionCountList, requestData, "POST")
            .then((result) => {
            let responseJson = result;
            if (responseJson.success == false) {
                this.setState({
                unpaidAmount: 0,
                total: 0,
                });
            } else {
                
                this.setState({
                unpaidAmount: responseJson.totalBalanceAmt,
                total: responseJson.totalTransAmt,
                totalCount: responseJson.totalCount,
                });
            }
            })
            .catch((error) => this.setState({ error}));
    }
    getSaleListData(_page,searchInvSend,pageCount, typeFilter, paymentStatusFilter){
        let _transArray = [];
        this.setState({isLoading: true})
        typeFilter = typeFilter ? typeFilter : this.state.typeFilter;
        paymentStatusFilter = paymentStatusFilter ? paymentStatusFilter : this.state.paymentStatusFilter;
        const requestData = JSON.stringify({
            business_id:this.state.businessId,
            company_id:this.state.company_id,
            type: typeFilter,
            payment_status: paymentStatusFilter,
            isDateFilter:true,
            start_date : this.state.startDate,
            end_date : this.state.endDate,
            pageCount:pageCount,
            search_inv_no:searchInvSend,
            page:_page
        });

        PostData(global.userSaleTransactionList, requestData,'POST').then((result) => {
            this.getTransactionAmountCalculate(_page,searchInvSend,pageCount, typeFilter, paymentStatusFilter);
            let responseJson = result;
            if(responseJson.success == false)
            {   
                this.setState({transactionArrayFilter:_transArray,itemArray:_transArray, isLoaded:true});
            }
            else
            {
                if (responseJson.response) {
                    _transArray = responseJson.response;
                    
                }
               
                
                _transArray.sort((a, b) => b.added_on - a.added_on);
                this.setState({transactionArrayFilter:_transArray,itemArray:_transArray,isLoaded:true, pageShow:responseJson.pageShow}); 
            }   
            this.setState({isLoading: false})          
        })
        .catch(error => this.setState({ error, isLoaded: false ,isLoading: false}));
    }
    
    deleteSaleReturn(value,type){
        if(value.isChequeMakePayment){
            confirmAlert({
                title: 'warning',
                message: "This transaction cannot be deleted because cheque associated with the transaction is already closed. Re-open the cheque to delete this transaction.",
                buttons: [
                {
                    label: 'OK',
                    className: 'btn btn-danger'
                }
                ]
            });
        }else if(value.paymentHistory.length > 0){
            confirmAlert({
                title: 'warning',
                message: "The payment link for this "+`${type == 'SALE' ? 'sale' : 'sale return'}`+" has already been processed,  i.e the payment has been "+`${type == 'SALE' ? 'received' : 'paid'}`+". Therefore, we cannot delete the "+`${type == 'SALE' ? 'sale' : 'sale return'}`+" transaction. If you want to delete this "+`${type == 'SALE' ? 'sale' : 'sale return'}`+" transaction, please ensure that you delete the entry of the linked transaction first.",
                buttons: [
                {
                    label: 'OK',
                    className: 'btn btn-danger'
                }
                ]
            });
        }else if(value.isReturn){
            confirmAlert({
                title: 'Confirm to delete',
                message: 'If you delete this transaction, all the return transactions related to it will also be deleted.Do you still want to delete?',
                buttons: [
                {
                    label: 'Yes',
                    className: 'btn btn-danger',
                    onClick: () => {
                        const requestData = JSON.stringify({
                            sale_id: value.id,
                            type_value: type
                        });
                        PostData(global.deleteWithReturnTransaction, requestData,'POST').then((result) => {
                            let responseJson = result;                
                            if(responseJson.success == false)
                            {
                                sendNotification("Error Message 😓",responseJson.message,"danger");
                                return;
                            }
                            else
                            {
                                sendNotification("Success Message 👍",responseJson.message,"success");
                                this.getSaleListData(this.state.page, this.state.searchInvNo, this.state.pageCount);
                                return;
                            }
                        });
                    }
                },
                {
                    label: 'No',
                    className: 'btn btn-dark',
    
                }
                ]
            });
        }else {
            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure you want to delete?',
                buttons: [
                    {
                        label: 'Yes',
                        className: 'btn btn-danger',
                        onClick: () => {
                            const requestData = JSON.stringify({
                                sale_id: value.id,
                                type_value: type
                            });
                            PostData(global.deleteSaleTransaction, requestData, 'POST').then((result) => {
                                let responseJson = result;
                                if (responseJson.success == false) {
                                    sendNotification("Error Message 😓", responseJson.message, "danger");
                                    return;
                                } else {
                                    sendNotification("Success Message 👍", responseJson.message, "success");
                                    this.getSaleListData(this.state.page, this.state.searchInvNo, this.state.pageCount);
                                    return;
                                }
                            });
                        }
                    },
                    {
                        label: 'No',
                        className: 'btn btn-dark',
                    }
                ]
            });
        }
    }

    loadTranscListing(){
        let dataList = [];
        let rows = [];
        if(this.state.isLoaded == true)
        {
            let _transDetails = this.state.transactionArrayFilter;
            if(_transDetails.length > 0){
                
                let _i = 0;
                console.log('_transDetails', JSON.stringify(_transDetails))
                _transDetails.map((value,index) => {
                    _i++;
                    let _trans_duplicate_normal = value.trans_duplicate_normal ? value.trans_duplicate_normal : '';
                    let _pageAK = this.state.setPage;
                    let _payType = <span className="badge badge-warning">UNPAID</span>;
                    if(value.payment_paid == 'PARTIAL'){
                        _payType = <span className="badge badge-info">{value.payment_paid}</span>;
                    }
                    else if(value.payment_paid == 'PAID'){
                        _payType = <span className="badge badge-success">{value.payment_paid}</span>;
                    }

                    let _type = "&tType="+value.type;
                    let _editActionUrl = '';
                    let _editDuplicateActionUrl = '/business/add-sale/?auth='+value.id;
                    if(value.type == 'SALE'){
                        _editActionUrl = global.webUrl+'business/add-sale/?auth='+value.id+_type;
                        _editDuplicateActionUrl = '/business/add-sale/?auth='+value.id+'&tType=DUPLICATE'
                    }
                    else if(value.type == 'CREDIT NOTE'){
                        _editActionUrl = global.webUrl+'business/add-sale-credit-note/?auth='+value.id;
                    }
                    let _showDupL = '';
                    if(_trans_duplicate_normal == 'Duplicate'){
                        _showDupL = ' (Duplicate)';
                    }
                    let _showInv = value.customPrefix+' #'+value.invoice_no_web;
                    if(value.type == "CREDIT NOTE"){
                        _showInv = value.customPrefix+' #'+value.invoice_no_return_web;
                    }

                    let showDateTime = moment(value.invoice_date).format('DD MMM, YY');
                    if(value.type == 'CREDIT NOTE'){
                        showDateTime = moment(value.invoice_date_return).format('DD MMM, YY');
                    }
                    if (_businessSetting.Tran_AddTime == 1) {
                        showDateTime += " " + value.invoice_time;
                    } 
                    rows.push({
                        srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
                        invoice_date: showDateTime,
                        invoice_no:_showInv + _showDupL,
                        party_name:value.party_name,
                        payment_type: value.type,//value.payType,
                        total_amount:numberFormat(value.total_amount),
                        // For CREDIT NOTE rows the actual customer refund lives
                        // in paid_amount; received_amount is the string "0".
                        // Using a truthy check `value.received_amount ? ...`
                        // picked the string "0" (truthy) and hid the real
                        // amount. Compare numerically instead.
                        received_amount: numberFormat(parseFloat(value.received_amount) > 0 ? value.received_amount : value.paid_amount),
                        balance_amount : numberFormat(value.balance),
                        pay_status: _payType,
                        action:(
                            <div className="btn-group" role="group">
                                <button type="button" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fa fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    {
                                        (value.type == 'SALE' && _trans_duplicate_normal == 'Normal' ) &&
                                        <Link className="dropdown-item" to={_editDuplicateActionUrl}>
                                            Duplicate
                                        </Link>
                                    }
                                    { _trans_duplicate_normal == 'Normal' &&
                                        <a className="dropdown-item" href={_editActionUrl}>
                                        View / Edit Details
                                    </a>
                                    }

                                    <a className="dropdown-item" onClick={this.deleteSaleReturn.bind(this,value, 'Sale Return')}>
                                        Delete
                                    </a>
                                    {
                                        value.type == 'SALE' ?
                                        <>
                                            <Link className="dropdown-item" to={'/business/challanPdfDialog/?auth='+value.id} target="_blank">
                                                Preview as Delivery Challan
                                            </Link>
                                            <DownloadBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                            <Link className="dropdown-item" to={'/business/salePdfDialog/?auth='+value.id} target="_blank">
                                                Preview
                                            </Link>
                                            <PrintBtnSaleInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                        </> :
                                        <>
                                            <DownloadBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                            <Link className="dropdown-item" to={'/business/saleReturnPdfDialog/?auth='+value.id} target="_blank">
                                                Preview
                                            </Link>
                                            <PrintBtnSaleReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                        </>
                                    }
                                </div>
                            </div>
                        )
                    });
                });
            }
        }


        if (rows) {
            dataList = {
                columns: columns,
                rows: rows
            };
        }
        return dataList;
    }

    handleCallBackDate = (start, end) => {
        this.setState({startDate:start.format('YYYY-MM-DD'),endDate:end.format('YYYY-MM-DD')});
        this.getSaleListData(this.state.page,this.state.searchInvNo,this.state.pageCount);
    };

    handleCallBackFilter(event){
        event.preventDefault();
        this.setState({isLoading: true});
        let _typeFilter = event.target.value;
        this.setState({typeFilter:_typeFilter});

        this.getSaleListData(this.state.page,this.state.searchInvNo,this.state.pageCount, _typeFilter);
    }

    handlePaymentStatusFilter = (event) => {
        event.preventDefault();
        this.setState({isLoading: true});
        let _paymentStatusFilter = event.target.value;
        this.setState({paymentStatusFilter:_paymentStatusFilter});

        this.getSaleListData(this.state.page,this.state.searchInvNo,this.state.pageCount, this.state.typeFilter, _paymentStatusFilter);
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }
        
        const {errors} = this.state;
        return(
            <React.Fragment>
                <div className="content">
                    <div className="content-header">
                        <div className="header-section">
                            {/* <h2 className="content-heading">Manage Business</h2> */}
                            <h1 className="content-heading">
                                <i className="gi gi-direction"></i>Manage Credit Note / Sale Return List<br/>
                            </h1>
                            
                            
                        </div>
                    </div>
                    <nav className="breadcrumb push">
                        <a className="breadcrumb-item" href={global.webUrl+"business/dashboard/"}>Dashboard</a>
                        <a className="breadcrumb-item" href={global.webUrl+"business/add-sale-credit-note/"}>Create New Credit Note / Sale Return</a>                        
                        <span className="breadcrumb-item active">Manage Return Credit Note / Sale Return List</span>
                    </nav>
                    

                    <div className="block">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block">
                                    <div className="block-content">
                                        <div className="row items-push">
                                            <div className="row col-lg-12">
                                                <div className="col-lg-9">
                                                    <span>Filter : </span>
                                                    <DateRangePicker
                                                        initialSettings={{
                                                            startDate: this.state.startDate,
                                                            endDate: this.state.endDate,
                                                            locale: {
                                                                format: 'YYYY-MM-DD',
                                                            },
                                                            ranges: {
                                                                Today: [moment().toDate(), moment().toDate()],
                                                                Yesterday: [
                                                                moment().subtract(1, 'days').toDate(),
                                                                moment().subtract(1, 'days').toDate(),
                                                                ],
                                                                'This Week': [
                                                                    moment().startOf('week').format("YYYY-MM-DD"),
                                                                    moment().endOf('week').format("YYYY-MM-DD"),
                                                                    ],
                                                                'This Month': [
                                                                    moment().startOf('month').toDate(),
                                                                    moment().endOf('month').toDate(),
                                                                ],
                                                                'Last Month': [
                                                                    moment().subtract(1, 'month').startOf('month').toDate(),
                                                                    moment().subtract(1, 'month').endOf('month').toDate(),
                                                                ],
                                                                'This Quarter': [
                                                                    moment().startOf('month').toDate(),
                                                                    moment().add(2, 'month').endOf('month').toDate(),
                                                                ],
                                                                'This Financial Year': [
                                                                    moment().month('April').startOf('month').format("YYYY-MM-DD"),
                                                                    moment().add(1, 'year').month('March').endOf('month').format("YYYY-MM-DD"),
                                                                ],
                                                            }
                                                        }}
                                                        onCallback={this.handleCallBackDate}
                                                    >
                                                    <input type="text" className="form-control col-4" style={{display: 'inline-block'}}/>
                                                    </DateRangePicker>

                                                    <select name="" onChange={this.handleCallBackFilter.bind(this)} className="form-control col-3 ml-20" style={{display: 'inline-block'}}>
                                                        <option value="Both">Sale & Cr. Note</option>
                                                        {/* The list/count APIs filter on 'SALE'; 'Sale' matched no rows. */}
                                                        <option value="SALE">Sale</option>
                                                        <option value="CREDIT NOTE">Cr. Note</option>
                                                    </select>
                                                    <select onChange={this.handlePaymentStatusFilter} className="form-control col-2 ml-10" style={{display: 'inline-block'}}>
                                                        <option value="ALL">All Status</option>
                                                        <option value="Paid">Paid</option>
                                                        <option value="Partial">Partial</option>
                                                        <option value="Unpaid">Unpaid</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className="row pb-20 pull-right">
                                                        <div className="text-right">
                                                            <button
                                                                type="button"
                                                                className="js-appear-enabled text-center vs-excel-btn"
                                                                onClick={this.exportToExcel}
                                                                disabled={this.state.isExporting}
                                                                title="Download current filter as Excel"
                                                            >
                                                                <div className="text-info">
                                                                    <i className={this.state.isExporting ? "fa fa-spinner fa-spin" : "fa fa-file-excel-o"}></i>
                                                                </div>
                                                                <div className="font-size-sm text-muted">
                                                                    {this.state.isExporting ? "Exporting…" : "Excel Export"}
                                                                </div>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <SaleTotalsCards paid={parseFloat(this.state.total) - parseFloat(this.state.unpaidAmount)} unpaid={this.state.unpaidAmount} total={this.state.total} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="block">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block">
                                    <div className="block-content">
                                        <h2 className="block-title ml-10">Transactions</h2>
                                        <input type="text" className="form-control col-6" style={{display:'inline-block'}} placeholder='search reference number (type at least three characters)'onChange={this.getInvoiceSearch}/>
                                        <Link to={"/business/add-sale-credit-note/"} className="pull-right btn btn-sm btn-primary">
                                            <i className="fa fa-plus-circle"></i> Add Credit Note
                                        </Link>
                                    </div>
                                    <div className="block-content" id="tableData" style={{margin:'10px'}}>
                                        <MDBDataTableV5
                                            hover
                                            span
                                            displayEntries={false}
                                            entries={100}
                                            pagingTop={false}
                                            searchTop={false}
                                            searchBottom={false}
                                            info={false}
                                            barReverse
                                            data={this.loadTranscListing()}
                                        />
                                    </div>

                                    <div style={{ float: "right", marginTop: "-15px" }}>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="d-flex align-items-center">
                                            <div role="status" aria-live="polite"> Rows per page:</div>
                                            </div>
                                            <div className="d-flex align-items-center" >
                                            <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                                    onChange={(event) => {
                                                        event.preventDefault();
                                                        const { name, value } = event.target;
                                                        //this.setState({ pageCount: value, setPage: 1 });
                                                        this.setState(prevState => ({
                                                                pageCount : value,
                                                                setPage : 1,
                                                            }),
                                                            () => {
                                                                this.getSaleListData(1,this.state.searchInvNo,
                                                                    value
                                                                );
                                                            });
                                                    }}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            </div>
                                            <div className="d-flex align-items-center">
                                            <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <div style={{ float: "left", marginTop: "-45px" }}>
                                        <PaginationControl
                                            between={this.state.pageCount}
                                            total={this.state.totalCount}
                                            limit={this.state.pageCount}
                                            changePage={(page) => {
                                            this.setState({ setPage: page });
                                            this.getSaleListData(page,this.state.searchInvNo,this.state.pageCount
                                            );
                                            }}
                                            ellipsis={1}
                                            activeClass={this.state.setPage}
                                            page={this.state.setPage}
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                

                
                <div id="global_loader" className={_loader}>
                    <div className="gl-ldr-cld">
                        <div className="gl-ldr-ctr">
                            <div className="gl-loader"></div>
                        </div>
                    </div>
                </div>

                {
                    this.state.isLoading && (
                        <Dialog >
                        <Loader type="converging-spinner" />
                        </Dialog>
                    )
                }
               
                {
                    this.state.isPdfLoading && (
                        <Dialog >
                            <div style={{textAlign: 'center'}}>
                                <Loader type="pulsing" />
                                <h5 style={{marginTop: '50px'}}>Please Wait ...</h5>
                            </div>
                        </Dialog>
                    )
                }

            </React.Fragment>
        )    
    }
}